<template>
  <div>
    <Head title="會員中心 - 個人資料" />
    <user-template title="會員中心">
      <template #header>個人資料</template>

      <main>
        <div class="form">
          <div class="form-title">
            <label for="name">姓名</label>
          </div>
          <div class="form-element">
            <InputText id="name" v-model="user.name" />
            <div class="form-element-sub">
              <RadioButton
                id="sex_mr"
                name="sex"
                :value="1"
                v-model="user.sex"
              /><label for="sex_mr">先生</label>
            </div>
            <div class="form-element-sub">
              <RadioButton
                id="sex_ms"
                name="sex"
                :value="0"
                v-model="user.sex"
              /><label for="sex_ms">小姐</label>
            </div>
          </div>
          <div v-if="$page.props.errors.name" class="error_information">
            {{ $page.props.errors.name }}
          </div>
        </div>

        <div class="form">
          <div class="form-title">
            <label for="email">電子郵件</label>
          </div>
          <div class="mt-1">
            <InputText id="email" v-model="user.email" class="w-full" />
            <div v-if="!user.email_verified_at" class="mt-1">
              <Button
                @click="resendVerificationEmail"
                :disabled="resend_verification_email != ''"
              >
                <template v-if="resend_verification_email == ''"
                  >重發驗證電子郵件</template
                >
                <template v-else-if="resend_verification_email == 'sending'"
                  >驗證電子郵件發送中</template
                >
                <template v-else-if="resend_verification_email == 'sent'"
                  >驗證電子郵件已發送</template
                >
              </Button>
            </div>
          </div>
          <div
            v-if="
              $page.props.errors.email ||
              user.email != user.email_confirmation ||
              !user.email_verified_at
            "
            class="error_information"
          >
            {{ $page.props.errors.email }}
            <template v-if="!user.email_verified_at"
              >電子郵件尚未驗證。</template
            >
            <template v-else-if="user.email != user.email_confirmation"
              >變更電子郵件將需要重新驗證。</template
            >
          </div>
        </div>

        <div class="form">
          <div class="form-title">
            <label for="mobile">行動電話</label>
          </div>
          <div class="mt-1">
            <InputText
              id="mobile"
              v-model="user.mobile"
              class="w-full"
              @input="checkSmsVerify"
            />
            <div v-if="sms.changed" class="mt-1">
              <InputText
                class="w-20"
                v-model="sms.verify"
                @input="smsVerify"
                :disabled="sms.is_verifying || sms.is_verifyed"
                :class="{
                  'p-invalid': $page.props.errors.mobile || sms.is_failed,
                }"
                placeholder="驗證碼"
              />
              <Button
                v-if="!sms.is_verifyed"
                @click="smsSend"
                :disabled="
                  sms.counting || sms.is_verifying || user.mobile.length < 10
                "
              >
                <template v-if="!sms.counting">發送驗證瑪</template>
                <template v-else>{{ timer }}秒後可重試</template>
              </Button>
              <i v-else class="pi pi-check ml-2" style="font-size: 1.2rem"></i>
            </div>
          </div>
          <div v-if="$page.props.errors.mobile" class="error_information">
            {{ $page.props.errors.mobile }}
          </div>
        </div>

        <div class="form">
          <div class="form-title">
            <label for="address">收件地址</label>
          </div>
          <div class="form-element-subs">
            <div class="form-element-sub">
              <Dropdown
                id="delivery_address"
                class="w-32"
                v-model="user.delivery.city"
                :options="taiwan_districts"
                optionLabel="name"
                placeholder="縣市"
                :filter="true"
                filterPlaceholder="尋找"
                emptyFilterMessage="沒有符合的結果"
                @change="user.delivery.district = null"
              />
              <Dropdown
                id="district"
                class="w-36"
                v-model="user.delivery.district"
                :options="selected_city_delivery_new_districts"
                optionLabel="name"
                placeholder="行政區"
                :filter="true"
                filterPlaceholder="尋找"
                emptyFilterMessage="沒有符合的結果"
                :disabled="!user.delivery.city"
              />
            </div>
            <div>
              <InputText
                v-model="user.delivery.address"
                class="w-64"
                type="text"
                placeholder="路名及門牌號碼"
                :disabled="!user.delivery.district"
              />
            </div>
          </div>
        </div>

        <div class="form">
          <div class="form-title">
            <label for="birthday">生日</label>
          </div>
          <div class="form-element">
            <Calendar
              @keydown.prevent=""
              v-model="birthday"
              dateFormat="yy 年 mm 月 dd 日"
              :maxDate="new Date()"
            />
          </div>
        </div>

        <div class="form">
          <div class="form-title">
            <label for="referral_by">上線推薦碼</label>
          </div>
          <div class="form-element">
            <InputText
              id="referral_by"
              v-model="user.referral_by_code"
              class="w-full"
              :disabled="$page.props.auth.user.referral_by_code"
            />
          </div>
          <div
            v-if="$page.props.errors.referral_by_code"
            class="error_information"
          >
            {{ $page.props.errors.referral_by_code }}
          </div>
        </div>

        <div class="form">
          <div class="form-title">
            <label for="referral_code">我的推薦碼</label>
          </div>
          <div class="form-element">
            {{ $page.props.auth.user.referral_code ?? "(空白)" }}
          </div>
        </div>

        <div class="form">
          <div class="form-title">
            <label for="payment_method">匯款資訊</label>
          </div>
          <div class="form-element-subs">
            <div>
              <Dropdown
                id="bank"
                class="w-72"
                v-model="user.bank"
                optionLabel="label"
                :options="taiwan_banks"
                placeholder="銀行名稱"
                :filter="true"
                filterPlaceholder="尋找"
                emptyFilterMessage="沒有符合的結果"
              />
            </div>
            <div>
              <InputText
                v-model="user.account"
                class="w-72"
                type="text"
                placeholder="銀行帳號"
              />
            </div>
          </div>
        </div>

        <div class="w-full pt-10 text-right">
          <Button label="儲存變更" @click="saveUser" />
        </div>
      </main>
    </user-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import UserTemplate from "./Shared/UserTemplate";
import TaiwanDistricts from "@/TaiwanDistricts.json";
import TaiwanBanks from "@/TaiwanBanks.json";
import InputText from "primevue/inputtext";
import RadioButton from "primevue/radiobutton";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Button from "primevue/button";

export default {
  components: {
    UserTemplate,
    InputText,
    RadioButton,
    Dropdown,
    Calendar,
    Button,
  },
  layout: Layout,
  watch: {
    timer: {
      handler(value) {
        if (this.sms.counting == true) {
          if (value > 0) {
            setTimeout(() => {
              this.timer--;
            }, 1000);
          } else {
            this.sms.counting = false;
          }
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      user: {
        name: null,
        sex: 1,
        email: null,
        mobile: null,
        delivery: {
          city: null,
          district: null,
          address: null,
        },
        birthday: null,
        referral_by_code: null,
        bank: {
          code: null,
          name: null,
          label: null,
        },
        account: null,
      },
      birthday: null,
      taiwan_districts: TaiwanDistricts,
      taiwan_banks: TaiwanBanks,
      timer: 0,
      sms: {
        changed: false,
        counting: false,
        verify: "",
        is_verifying: false,
        is_verified: false,
        is_failed: false,
      },
      resend_verification_email: "",
      resend_verification_sms: "",
    };
  },
  methods: {
    doNothing() {},
    checkSmsVerify() {
      this.sms.is_failed = false;
      if (this.user.mobile != this.user.mobile_confirmation) {
        this.sms.is_verifyed = false;
        this.sms.verify = "";
        this.sms.changed = true;
      } else {
        this.sms.is_verifyed = true;
      }
    },
    smsSend() {
      this.sms.counting = true;
      this.timer = 60;

      axios
        .post(route("sms.send_verification"), {
          mobile: this.user.mobile,
        })
        .then((response) => {
          if (response.data.successed == true) {
            this.$toast.add({
              severity: "success",
              summary: "手機驗證碼已發送",
              detail:
                "請將您收到的六位數字驗證碼輸入於驗證碼欄位完成手機驗證。",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "手機驗證碼發送失敗",
              detail:
                response.data.error +
                "如一直無法進行驗證，請與客服聯繫取得進一步的協助。",
              life: 10000,
            });
          }
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "無法發送手機驗證碼",
            detail:
              "請檢查您的網路連線後再試一次。如一直無法進行驗證，請與客服聯繫取得進一步的協助。",
            life: 10000,
          });
        });
    },
    smsVerify() {
      this.sms.is_failed = false;
      if (this.sms.verify.length >= 6) {
        this.sms.is_verifying = true;
        axios
          .post(route("sms.verify"), {
            mobile: this.user.mobile,
            code: this.sms.verify,
          })
          .then((response) => {
            if (response.data.mobile === this.user.mobile) {
              this.user.mobile_confirmation = response.data.mobile;
              this.sms.is_verifyed = true;
            } else {
              this.sms.is_failed = true;
              this.sms.verify = "";
              this.$toast.add({
                severity: "error",
                summary: "手機驗證碼錯誤",
                detail: "請檢查您所收到的手機驗證碼後再試一次。",
                life: 10000,
              });
            }
          })
          .finally(() => {
            this.sms.is_verifying = false;
          });
      }
    },
    resendVerificationEmail() {
      this.resend_verification_email = "sending";
      axios
        .post(route("verification.send"))
        .then((response) => {
          this.$toast.add({
            severity: "success",
            summary: "已重新發送驗證電子郵件",
            detail: "請至您的信箱收取驗證電子郵件進行下一步動作。",
            life: 3000,
          });
          this.resend_verification_email = "sent";
          setTimeout(() => {
            this.resend_verification_email = "";
          }, 3 * 60 * 1000);
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "發送驗證電子郵件失敗",
            detail: "請聯繫我們取得進一步的協助。",
            life: 10000,
          });
          this.resend_verification_email = "";
        });
    },
    saveUser() {
      if (this.birthday != null) {
        var date = this.birthday,
          month = "" + (date.getMonth() + 1),
          day = "" + date.getDate(),
          year = date.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        this.user.birthday = [year, month, day].join("-");
      }

      let payload = {
        name: this.user.name,
        sex: this.user.sex,
        email: this.user.email,
        mobile: this.user.mobile,
        mobile_confirmation: this.user.mobile_confirmation,
        shipping_info: {
          city: this.user.delivery.city?.name,
          district: this.user.delivery.district,
          address: this.user.delivery.address,
        },
        birthday: this.user.birthday,
        referral_by_code: this.user.referral_by_code,
        payment_method: {
          code: this.user.bank?.code ?? null,
          name: this.user.bank?.name ?? null,
          account: this.user.account ?? null,
        },
      };

      this.$inertia.post(route("user.profile"), payload, {
        // only: ["errors", "flash"],
        preserveState: true,
        preserveScroll: true,
        onSuccess: (page) => {
          this.updateUserProfile();
        },
      });
    },
    updateUserProfile() {
      this.user = {
        name: this.$page.props.auth.user.name,
        sex: this.$page.props.auth.user.sex,
        email: this.$page.props.auth.user.email,
        email_confirmation: this.$page.props.auth.user.email,
        email_verified_at: this.$page.props.auth.user.email_verified_at,
        mobile: this.$page.props.auth.user.mobile,
        mobile_confirmation: this.$page.props.auth.user.mobile,
        delivery: {
          city:
            this.taiwan_districts.find((city) => {
              return (
                city.name == this.$page.props.auth.user.shipping_info?.city
              );
            }) ?? null,
          district: this.$page.props.auth.user.shipping_info?.district ?? null,
          address: this.$page.props.auth.user.shipping_info?.address ?? null,
        },
        referral_by_code: this.$page.props.auth.user.referral_by_code ?? null,
        bank:
          this.taiwan_banks.find((bank) => {
            return bank.name == this.$page.props.auth.user.payment_method?.name;
          }) ?? null,
        account: this.$page.props.auth.user.payment_method?.account ?? null,
      };

      this.birthday =
        this.$page.props.auth.user.birthday == null
          ? null
          : new Date(this.$page.props.auth.user.birthday);

      if (this.user.referral_by_code == null) {
        if (this.used_referral_code != null)
          this.user.referral_by_code = this.used_referral_code;
      }
    },
  },
  computed: {
    selected_city_delivery_new_districts() {
      if (!this.user.delivery.city) return [];
      return this.user.delivery.city.districts;
    },
    used_referral_code() {
      let name = "referred_code";
      let match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      if (match) return match[2];
      return null;
    },
  },
  mounted() {
    this.updateUserProfile();
  },
};
</script>